import React, { useState } from 'react';
import { Check, Star, ChevronDown } from 'lucide-react';
import { formatUsd } from '../config/membership';
import { trackEvent } from '../utils/tracking';
import MembershipTierDetails from './MembershipTierDetails';
import './MembershipCard.css';

export default function MembershipCard({ tier, selected, onSelect }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const handleSelect = () => {
    trackEvent('Membership Tier Selected', { tier: tier.key });
    onSelect(tier.key);
  };

  const toggleDetails = (e) => {
    e.stopPropagation();
    const opening = !detailsOpen;
    setDetailsOpen(opening);
    if (opening) trackEvent('Membership Details Expanded', { tier: tier.key });
  };

  return (
    <div
      className={`tp-membership-card card${selected ? ' tp-membership-card--selected' : ''}${tier.popular ? ' tp-membership-card--popular' : ''}`}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelect();
        }
      }}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
    >
      {tier.popular && (
        <span className="tp-membership-card__chip label-s">
          <Star size={12} strokeWidth={0} fill="currentColor" />
          Most popular
        </span>
      )}
      <h3 className="title-l tp-membership-card__name">{tier.name}</h3>
      <p className="body-s tp-membership-card__tagline">{tier.tagline}</p>
      <div className="tp-membership-card__price-row">
        <span className="display-3 tp-membership-card__price">{formatUsd(tier.priceCents)}</span>
        <span className="body-s tp-membership-card__price-caption">per traveler / year</span>
      </div>
      <p className="tp-membership-card__trips">Up to {tier.tripsPerYear} international trips</p>
      <ul className="tp-membership-card__features">
        {tier.features.slice(1).map((f) => (
          <li key={f}>
            <span className="tp-membership-card__check">
              <Check size={13} strokeWidth={2.5} />
            </span>
            <span className="body-m">{f}</span>
          </li>
        ))}
      </ul>
      <p className="body-s tp-membership-card__value">
        Over {formatUsd(tier.valueCents)} in value
      </p>
      <p className="body-s tp-membership-card__note">
        Activate each trip as it comes up — same eSIM + lounge delivery as a one-time purchase, just spread across the year.
      </p>

      <button type="button" className="tp-membership-card__toggle" onClick={toggleDetails} aria-expanded={detailsOpen}>
        {detailsOpen ? 'Hide details' : 'See what\'s included'}
        <ChevronDown size={16} strokeWidth={1.5} className={`tp-membership-card__toggle-chevron${detailsOpen ? ' tp-membership-card__toggle-chevron--open' : ''}`} />
      </button>

      {detailsOpen && <MembershipTierDetails tier={tier} />}
    </div>
  );
}
